import i18n from 'src/i18n.js';
const t = (key) => i18n.t(key);

export const physicianDetailsTabs = () => [
    { id: 'physicianDetails', label: t('more.common.PhysicianDetails') },

    {
        id: 'associatedAccounts',
        label: t('admin.nameDetails.associatedAccount'),
    },

    { id: 'notes', label: t('accounts.accountDetailCard.notes') },
];
